import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { translateText } from '../../../lib/api/api'

interface Props { text: string; targetLanguage: string }

/** "Traduzione non ufficiale" of one source, on request (server POST /translate). */
export default function SourceTranslation({ text, targetLanguage }: Props) {
  const { t } = useTranslation()
  const [state, setState] = useState<'idle' | 'loading' | 'done' | 'error'>('idle')
  const [result, setResult] = useState<{ translation: string; disclaimer: string } | null>(null)
  const [open, setOpen] = useState(false)

  const run = async () => {
    if (result) { setOpen(!open); return }
    setState('loading')
    try {
      const res = await translateText(text, targetLanguage)
      setResult(res.data)
      setOpen(true)
      setState('done')
    } catch {
      setState('error')
    }
  }

  return (
    <span className="ml-1">
      <button type="button" onClick={run} disabled={state === 'loading'}
        className="text-[10px] underline text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
        {state === 'loading' ? t('chat.sources.translating') : open ? t('chat.sources.hideTranslation') : t('chat.sources.translate')}
      </button>
      {state === 'error' && <span className="block text-[11px] text-red-600">{t('chat.sources.translationError')}</span>}
      {open && result && (
        <span className="block mt-1 p-2 rounded bg-gray-50 dark:bg-gray-800 text-gray-800 dark:text-gray-100 whitespace-pre-line">
          {result.translation}
          <span className="block mt-1 text-[10px] italic text-gray-500">{result.disclaimer}</span>
        </span>
      )}
    </span>
  )
}
